<nav class="navbar navbar-expand-lg navbar-light fixed-top header-theme-color header-border">
    <div class="container-fluid ol-menu-div">
        <a class="navbar-brand" href="#">OneLog</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link active header-font-color" aria-current="page" routerLink="/list-reports">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active header-font-color logout-link" aria-current="page" (click)="logout()">Logout</a>
                </li>
            </ul>
        </div>
    </div>
</nav>